namespace Matrix.Workflow {
    export class DataQualityWorkflowColumns {
        static columnsKey = 'Workflow.DataQualityWorkflow';
    }
}
